import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { CarouselLinkModel } from 'models';

import { UitkLinkTypeSize } from 'uitk-react-link';

import { onClickScrollToTarget } from 'utils/smooth-scroll';

function handleClick() {
  onClickScrollToTarget({ scrollTo: 0 });
}

const LinkTracked = ClickTracker(Link);

export interface CarouselLinkProps {
  linkComponent: React.ReactType;
  linkModel: CarouselLinkModel;
}

export const CarouselCardLink: React.FunctionComponent<CarouselLinkProps> = props => {
  const { linkComponent, linkModel } = props;

  if (!linkComponent || !linkModel) {
    return null;
  }

  const LinkTag: React.ReactType = linkComponent;

  return (
    <LinkTag type={UitkLinkTypeSize[linkModel.type]} inline={linkModel.inline}>
      <LinkTracked onClick={handleClick} linkName={linkModel.linkName} rfrr={linkModel.rfrr} to={linkModel.url}>
        {linkModel.text}
      </LinkTracked>
    </LinkTag>
  );
};
